angular.module('gym.components').directive('ezidebitCreditCardForm', function() {
  return {
    restrict: 'EA',
    scope: {
      gym: '=',
      contact: '=',
      customer: '=',
      updateThisContactOnly: '=',
      paymentAccount: '=',
      closeModal: '&',
      isCustomerExist: '&',
      onCreate: '&',
      onUpdate: '&'
    },
    template: require('templates/components/contacts/wallet/ezidebit_credit_card_form.html.slim'),
    controller: ["$scope", "$timeout", "CreditCardValidationService", "CreditCardExpirationDatesService", "EzidebitService", function($scope, $timeout, CreditCardValidationService, CreditCardExpirationDatesService, EzidebitService) {
      var card, enableForm, endpoint, getWalletDetails, initChangePaymentDetails, initCreateCustomer, onCreate, onError, onSuccess, onUpdate, publicKey;
      publicKey = $scope.paymentAccount.public_key;
      endpoint = $scope.paymentAccount.payment_system_url;
      $scope.card = card = {
        firstName: $scope.contact.contact_information.first_name,
        lastName: $scope.contact.contact_information.last_name
      };
      $scope.years = CreditCardExpirationDatesService.getYears();
      $scope.months = CreditCardExpirationDatesService.getMonths();
      $scope.customerReference = EzidebitService.getCustomerReference({
        gymId: $scope.gym.id,
        contactId: $scope.contact.id,
        context: 'CP'
      });
      initChangePaymentDetails = function() {
        return $timeout(function() {
          window.initEziDebit();
          return eziDebit.init(publicKey, {
            submitAction: 'ChangeCustomerPaymentInfo',
            submitButton: 'submit-ezidebit-credit-card-form',
            submitCallback: onUpdate,
            submitError: onError,
            customerRef: 'customerRef',
            nameOnCard: 'nameOnCard',
            cardNumber: 'cardNumber',
            cardExpiryMonth: 'expiryMonth',
            cardExpiryYear: 'expiryYear'
          }, endpoint);
        });
      };
      initCreateCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'SaveCustomer',
            submitButton: 'submit-ezidebit-credit-card-form',
            submitCallback: onCreate,
            submitError: onError,
            customerFirstName: 'firstName',
            customerLastName: 'lastName',
            nameOnCard: 'nameOnCard',
            cardNumber: 'cardNumber',
            cardExpiryMonth: 'expiryMonth',
            cardExpiryYear: 'expiryYear',
            customerReference: 'customerReference'
          };
          if ($scope.customer.clean_contact_email) {
            params.customerEmail = 'customerEmail';
          }
          if ($scope.customer.clean_contact_mobile_number) {
            params.customerMobile = 'customerMobile';
          }
          window.initEziDebit();
          return eziDebit.init(publicKey, params, endpoint);
        });
      };
      if ($scope.isCustomerExist()) {
        initChangePaymentDetails();
      } else {
        initCreateCustomer();
      }
      $scope.checkCardNumber = function() {
        var ref;
        card.number = (ref = card.number) != null ? ref.replace(/[^0-9]/g, '') : void 0;
        return $scope.creditCardValid = CreditCardValidationService.check(card.number);
      };
      $scope.nameValid = function(name) {
        return CreditCardValidationService.nameValid(name);
      };
      $scope.isFormValid = function() {
        return $scope.card.form.$valid && $scope.creditCardValid && $scope.nameValid($scope.card.cardholderName);
      };
      $scope.$watch('isFormValid()', function(value) {
        return $scope.$emit('contact:paymentMethod:formStatusChanged', value);
      });
      onSuccess = function(response) {
        card.error_message = void 0;
        enableForm();
        return getWalletDetails(response.Data);
      };
      onUpdate = function(response) {
        return $timeout(function() {
          var customer;
          customer = onSuccess(response);
          return $scope.onUpdate({
            customer: customer
          });
        });
      };
      onCreate = function(response) {
        return $timeout(function() {
          var customer;
          customer = onSuccess(response);
          return $scope.onCreate({
            customer: customer
          });
        });
      };
      onError = function(error) {
        return $timeout(function() {
          enableForm();
          return card.error_message = error;
        });
      };
      getWalletDetails = function(customer) {
        var length, wallet;
        length = card.number.length;
        wallet = {
          customer_ref: customer.CustomerRef || $scope.customer.customer_ref,
          last4: card.number.substr(length - 4),
          full_name: card.cardholderName,
          exp_month: card.expirationMonth,
          exp_year: card.expirationYear,
          rootObjectName: 'payment_method',
          payment_method: 'credit_card'
        };
        wallet.bsb = '';
        return wallet;
      };
      return enableForm = function() {
        return $scope.isFormDisabled = false;
      };
    }]
  };
});
